import { apiReq } from "utils/api/apiReq";

export const fetchCsrfToken = async () => {
  const { data } = await apiReq<{ csrfToken: string }>("POST", "/v1/csrfToken");
  return data.csrfToken;
};
